import React, { Component } from 'react'
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
  Typography,
} from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import Collapse from '@mui/material/Collapse'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import PrivilegeListRow from './PrivilegeListRow'
import { getAccent, hexToRgba } from './constants'

export class PrivilegesTree extends Component {
  render () {
    const { classes = {}, data, open = {}, themecolors = {} } = this.props
    if (!data) return null

    const accent = getAccent(themecolors)
    const bg = themecolors.backgroundColor || themecolors.white || '#fff'
    const text = themecolors.textColor || '#101828'
    const muted = themecolors.themeDarkColor || '#667085'
    const panelBg = themecolors.lightGrey || themecolors.inputFieldBg || '#F9FAFB'

    const isOpen = !!open[data.key]
    const children = Array.isArray(data.children) ? data.children : []
    const selectedCount = children.filter(c => c.checked).length
    const totalCount = children.length
    const groupTitle = data.key
      ? this.props.translate(data.key === 'poi' ? data.key + 'H' : data.key)
      : ' '

    return (
      <Paper
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: isOpen
            ? hexToRgba(accent, 0.3)
            : hexToRgba(accent, 0.1),
          borderRadius: '10px',
          overflow: 'hidden',
          backgroundColor: bg,
          transition: 'border-color 0.15s ease',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            px: 1.5,
            py: 1,
            backgroundColor: bg,
            borderBottom: isOpen
              ? `1px solid ${hexToRgba(accent, 0.1)}`
              : 'none',
          }}
        >
          <IconButton
            size="small"
            onClick={() => this.props.handleClick(data.key)}
            sx={{ color: muted }}
          >
            {isOpen ? (
              <ExpandLess fontSize="small" />
            ) : (
              <ExpandMore fontSize="small" />
            )}
          </IconButton>

          <Box
            sx={{ flex: 1, minWidth: 0, cursor: 'pointer' }}
            onClick={() => this.props.handleClick(data.key)}
          >
            <Tooltip title={data.description || groupTitle || ''}>
              <Typography
                variant="subtitle2"
                noWrap
                sx={{ fontWeight: 600, lineHeight: 1.3, color: text }}
              >
                {groupTitle}
              </Typography>
            </Tooltip>
            <Typography variant="caption" sx={{ color: muted }}>
              {selectedCount}/{totalCount}{' '}
              {this.props.translate('selected') || 'selected'}
            </Typography>
          </Box>

          <FormControlLabel
            sx={{
              m: 0,
              mr: 0.5,
              '& .MuiFormControlLabel-label': {
                fontSize: 12,
                color: muted,
                whiteSpace: 'nowrap',
              },
            }}
            control={
              <Checkbox
                size="small"
                checked={!!data.checkedAll}
                onChange={e => this.props.handleChange(e, 'parent', data)}
                classes={{
                  root: classes.root,
                  checked: classes.checked,
                }}
                sx={{
                  color: accent,
                  '&.Mui-checked': { color: accent },
                }}
              />
            }
            label={this.props.translate('selectAll')}
          />
        </Box>

        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: '1fr 1fr',
                md: '1fr 1fr 1fr',
              },
              gap: 0.75,
              p: 1.25,
              backgroundColor: panelBg,
            }}
          >
            {children.map(item => (
              <PrivilegeListRow
                key={item.id}
                childData={item}
                classes={classes}
                translate={this.props.translate}
                handleChange={this.props.handleChange}
                themecolors={themecolors}
              />
            ))}
          </Box>
        </Collapse>
      </Paper>
    )
  }
}

export const PrivilagesTree = PrivilegesTree

export default PrivilegesTree
